/**
 *
 * @param endDate required
 * @param startDate optional (if not given get the minute difference with current time)
 * @returns minute difference in number
 */
export const timeDifference = (endDate, startDate = null) => {
	// check if end date is already expired
	if (new Date(endDate).getTime() > 0) {
		// if start date is not given then get the difference using end date and current date
		let difference = startDate
			? new Date(endDate).getTime() - new Date(startDate).getTime()
			: new Date(endDate).getTime() - new Date().getTime();

		// check if date is negative
		if (difference > 0) {
			let minutesDifference = difference / 1000 / 60;
			return minutesDifference;
		}
	}
	return 0;
};
